import { SectionHighlightsProps } from '@portfolio/models'
import { SectionWrapper } from '@portfolio/components'
import { styled } from '@portfolio/styles'

const StyledSectionWrapper = styled(SectionWrapper, {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '$48',
  containerSpace: 'medium',

  '@md': {
    alignItems: 'flex-start',
  },

  '@lg': {
    alignItems: 'center',
    gap: '$64',
    paddingInline: '$30',
  },
})

const Title = styled('h2', {
  projectFont: 'heading04',
  color: '$white',
  textAlign: 'left',
  margin: 0,
  fontSize: '36px',

  '@lg': {
    textAlign: 'center',
  },
})

const HighlightsWrap = styled('ul', {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '$40',
  width: '100%',
  margin: 0,
  padding: 0,
  listStyle: 'none',
  justifyItems: 'start',

  '@md': {
    maxWidth: '840px',
  },

  '@lg': {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '$64',
    maxWidth: '1168px',
    justifyItems: 'center',
  },
})

const Highlight = styled('li', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '$16',
  color: '$white',

  '@lg': {
    maxWidth: '345px',
  },
})

const HighlightTitle = styled('h3', {
  projectFont: 'ui02',
  color: '$white',
  width: 'max-content',
  maxWidth: '100%',
  margin: 0,
  padding: '$8 $16',
  borderRadius: '$rMax',
  backgroundColor: '$white_005',
})

const HighlightDescription = styled('p', {
  projectFont: 'heading08',
  color: '$white',
  margin: 0,
})

export const SectionHighlights = ({
  title,
  highlights,
  spacing,
  topBorder,
}: SectionHighlightsProps) => {
  return (
    <StyledSectionWrapper type={spacing} topBorder={topBorder}>
      {title && <Title>{title}</Title>}
      {highlights && highlights.length > 0 && (
        <HighlightsWrap>
          {highlights.map(({ _key, title, description }) => {
            return (
              <Highlight key={_key}>
                {title && <HighlightTitle>{title}</HighlightTitle>}
                {description && (
                  <HighlightDescription>{description}</HighlightDescription>
                )}
              </Highlight>
            )
          })}
        </HighlightsWrap>
      )}
    </StyledSectionWrapper>
  )
}
